import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { StorageService } from 'src/app/services/storage-service.service';
import { MenuItem } from 'src/app/shared/interfaces/data.interfaces';

@Component({
  selector: 'app-external-user-side-bar',
  templateUrl: './external-user-side-bar.component.html',
  styleUrl: './external-user-side-bar.component.scss',
  standalone:false
})
export class ExternalUserSideBarComponent {
  permissionService = inject(NgxPermissionsService);
  storageService = inject(StorageService);
  router = inject(Router);

  @Input() sidebarMenu: MenuItem[];
  @Input() moduleTitle: string;
  @Input() moduleIconType: string;
  @Input() moduleIconTitle: string;

  menuData: MenuItem[];

  userPermissions = this.permissionService.getPermissions();

  ngOnInit(): void {
    this.menuData = this.sidebarMenu;
    console.log("moduleIconTitle",this.moduleIconTitle)
  }

  isActiveRoute(children: MenuItem[]) {
    return children?.findIndex( d => d?.route === this.router?.url) > -1;
  }

  getChildrenPermission(children: MenuItem[]): boolean {
    const permissionsExist: any = [];
    children?.forEach( c => permissionsExist.push(...c?.permissions));
    return this.has(Object.keys(this.userPermissions), permissionsExist);
  }

  protected has(arr: string[], valuesToCheck: string[]): boolean {
    for (const value of valuesToCheck) {
      if (arr.includes(value)) {
        return true;
      }
    }
    return false;
  }
}
